<template>
  <section class="section7 text-center">
    <div class="container">
      <div class="row">
        <div class="col-12 pr-0">
          <div class="tableResult" :style="tableResultStyle">
            <ul>
              <li v-for="(level, index) in graphLevels" :key="index">
                <strong :style="strongStyle()">{{ level }}</strong>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 pl-0">
          <div>
            <p class="lightblueTxt mb-4">{{ $t('main.inhaler.heading') }}</p>
            <div class="lightblue_btn_gradient inspiratory-btn" style="background: url('images/blue-bg.png');">
              <a href="javascript:void(0)">
                <img src="images/inspiratory-img.png" alt="Table Result" class="d-block img-fluid"/>
                <div class="middleTxt">
                  <span>{{ maxFlowDampened }}</span>
                  <strong>L/min</strong>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row"> 
        <div class="col-12">
          <button class="btn blueBtn2 mt-4" @click="$router.push('/main/select-inhaler')">{{ $t('main.result.view_result') }}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      graphLevels: [310, 300, 270, 240, 210, 180, 150, 120, 90, 60, 30]
    }
  },

  computed: {
    ...mapGetters({
      selectedDevice: 'inhaler/selectedDevice',
      maxFlowDampened: 'inhaler/maxFlowDampened',
      maxFlowDampened1: 'inhaler/maxFlowDampened1',
      resistanceFactor: 'inhaler/resistanceFactor',
      result: 'inhaler/result',
    }),
    tableResultStyle() {
      const maxValue = 310;
      const minValue = 30;
      const range = maxValue - minValue;
      const clampedValue = Math.max(minValue, Math.min(this.maxFlowDampened, maxValue));
      const percentage = ((maxValue - clampedValue) / range) * 100;
      return `height: 360px; background: linear-gradient(to bottom, transparent ${percentage}%, #bee5e6 ${percentage}%); border: 1px solid red;`;
    }
  },
  methods: {
    strongStyle() {
      return 'padding: 3px 8px;';
    }
  }
}
</script>

<style>
.disabled-button {
  background-color: gray;
  color: white;
  cursor: not-allowed;
}
</style>